export default __webpack_public_path__ + "static/media/Landing_page_feature_1.aeaf005f.png";